

































































import { MediaItem, Work } from "@/api/models";
import {
  OptionItem,
  SiteState,
  SubmissionState,
} from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import FigureWidget from "./FigureWidget.vue";
import DisplayOptionSet from "./DisplayOptionSet.vue";
import MultiMediaPlayer from "./MultiMediaPlayer.vue";
import PdfFrame from "./PdfFrame.vue";
import ModelFrame from "./ModelFrame.vue";
import { emptyString, notEmptyString } from "../../api/validators";
import { bus } from "@/main";
import HelpWidget from "./HelpWidget.vue";
import { expandPath } from "@/api/helpers";

@Component({
  components: {
    FigureWidget,
    MultiMediaPlayer,
    DisplayOptionSet,
    HelpWidget,
    PdfFrame,
    ModelFrame,
  },
  filters: {},
})
export default class MediaForm extends Vue {
  @Prop({ default: () => new Work() }) work: Work;
  @Prop({ default: "" }) mediaItemId: string;
  @Prop({ default: -1 }) index: number;
  @State("site") site: SiteState;
  @State("submission") submission: SubmissionState;
  @Action("assignSubmission", { namespace: "submission" })
  assignSubmission: Function;

  item: MediaItem = new MediaItem();

  updating = false;

  created() {
    this.sync();
    bus.$on("saving-work", ({ workId }) => {
      if (workId === this.work._id) {
        this.updating = false;
        this.assignItem(false);
      }
    });
    bus.$on("media-saved", ({ mediaItemId }) => {
      if (mediaItemId === this.mediaItemId) {
        this.sync(true);
      }
    });
    bus.$on('alt-text-update', ({ subId, mediaId, altText }) => {
      const hasAltText = notEmptyString(this.item.alt);
      if (!hasAltText && notEmptyString(subId) && notEmptyString(mediaId) && mediaId === this.mediaItemId && notEmptyString(altText)) {
        this.item.alt = altText;
      }
    })
  }

  get isNew() {
    return emptyString(this.work._id, 12);
  }

  get isImage() {
    return this.item.isImage;
  }

  get isRemote() {
    return (
      this.hasItem && this.item.source !== "local" && notEmptyString(this.item.filename, 8)
    );
  }

  get isPdf() {
    return this.hasItem && this.item.mime.endsWith('pdf');
  }

  get isNotPdf() {
    return !this.isPdf;
  }

  get isModel() {
    return this.item.type === 'model';
  }

  get hasItem() {
    const {mime} = this.item;
    return notEmptyString(mime);
  }

  get isVideo() {
    return this.hasItem && (this.item.type === "video" || this.item.mime.startsWith("video"));
  }

  get isMultiMedia() {
    return (this.isRemote && !this.isImage && !this.isPdf) || this.isVideo;
  }

  get isEmbed() {
    return (
      (this.isRemote && this.item.source !== "cloudinary") || !this.isImage
    );
  }

  get displayOptionRows(): Array<OptionItem> {
    return [];
  }

  get mediaId() {
    return ['media-item-', this.mediaItemId].join('-');
  }

  get mediaDescLabel() {
    return this.isPdf ? this.site.label('pdf_description') : this.site.label('description');
  }

  get altTextHelpKey() {
    return this.isPdf ? 'pdf_alt_text_help' : 'alt_text_help';
  }

  get titleHelpKey() {
    return this.isPdf ? 'pdf_title_help' : 'title_help';
  }

  updateDisplayOptions(displayOpts = null, mediaId = '') {
    if (displayOpts instanceof Object && mediaId === this.mediaItemId) {
      this.item.displayOptions = displayOpts;
    }
  }

  update() {
    if (!this.updating) {
      this.updating = true;
      this.assignItem();
    }
  }

  assignItem(tempSave = true) {
    const workIndex = this.submission.works.findIndex(
      (w) => w._id === this.work._id
    );
    if (workIndex >= 0) {
      const mi = this.submission.works[workIndex].mediaItems.findIndex(
        (item) => item._id === this.mediaItemId
      );
      if (mi >= 0) {
        this.submission.works[workIndex].mediaItems[mi] = this.item;
        this.assignSubmission(this.submission);
        if (tempSave) {
          this.$ls.set("submission", this.submission);
        }
      }
    }
    bus.$emit('active', true);
    bus.$emit('media-updated', { workId: this.work._id });
    setTimeout(() => {
      this.updating = false;
    }, 125);
  }

  sync(checkLocalExists = false) {
    if (notEmptyString(this.mediaItemId, 12)) {
      const matched = this.work.mediaItems.find(
        (mi) => mi._id === this.mediaItemId
      );
      if (matched instanceof MediaItem) {
        const { filename, type } = matched;
        if (type === 'image' && !/^https?:/.test(filename) && checkLocalExists) {
          const path = expandPath(filename, "thumb");
          const img = new Image();
          img.src = path;
          img.onload = () => {
            this.item = matched;
            setTimeout(()=> {
            const imgTag = document.querySelector('#' + this.mediaId + ' figure img');
            if (imgTag instanceof HTMLElement) {
              const enterEvent = new Event('mouseenter');
              imgTag.dispatchEvent(enterEvent);
            }
            }, 500);
          }
        } else {
          this.item = matched;
        }
      }
    }
  }

  toggleSort() {
    bus.$emit('toggle-sort', true);
  }

/*   disableSort() {
    bus.$emit('toggle-sort', false);
  } */

  remove() {
    bus.$emit("remove-media", {
      workId: this.work._id,
      mediaItemId: this.mediaItemId,
      index: this.index,
    });
  }
  openUpload() {
    const { _id } = this.item;
    if (notEmptyString(_id) && this.item.isImage) {
      bus.$emit("upload-ref", { refKey: _id, type: "work" });
    }
  }

  @Watch("item.title")
  changeItem() {
    this.update();
  }

  @Watch("item.alt")
  changeAlt() {
    this.update();
  }

  @Watch("item.url")
  changeUrl() {
    this.update();
  }

  @Watch("item.description")
  changeDescription() {
    this.update();
  }
}
